<!-- filepath: /Users/minus4/Kod/Bitbucket/new-muzible-www-login/src/views/Auth2fa.vue -->

<template>
  <div class="auth2fa-root">
    <div class="auth2fa-scroll-container">
      <div class="auth2fa-content-wrapper">
        <div class="fonts-white">
          
          <!-- Logo Section -->
          <div class="logo-section">
            <LogoWhite @click="handleClickMenu('muzible')" class="logo-clickable"></LogoWhite>
          </div>

          <!-- Typing Animation Header -->
          <div class="typing-section">
            <div class="typing-container">
              <div class="fonts-head typing-text" id="feature-text">
                {{ dynamicText }}
                <span class="cursor"></span>
              </div>
            </div>
          </div>

          <!-- Auth2fa Card -->
          <div class="auth2fa-card-section">
            <div class="auth2fa-card">
              <v-card class="auth2fa-form-card">
                <v-card-text class="auth2fa-form-content">
                  
                  <!-- OTP Input Form -->
                  <v-form ref="formlogin" v-model="validLogin" id="check-login-form">
                    <div class="otp-wrapper">
                      <div class="otp-container">
                        <v-otp-input 
                          v-model="auth2facode" 
                          :disabled="loading" 
                          type="number" 
                          length="6" 
                          color="#1ff050"
                          @finish="onFinish()" 
                          class="otp-input"
                        ></v-otp-input>
                        
                        <!-- Loading Overlay -->
                        <div v-show="loading" class="otp-loading-overlay">
                          <v-progress-circular indeterminate color="#1ff050" size="48"></v-progress-circular>
                        </div>
                      </div>
                    </div>
                  </v-form>

                  <!-- Countdown Timer -->
                  <div class="countdown-section">
                    <div class="countdown-container">
                      <v-icon size="18" class="countdown-icon">mdi-timer-outline</v-icon>
                      <span v-if="this.countdown > 1" class="countdown-text">
                        You have {{ countdown }} seconds to enter valid code
                      </span>
                      <span v-if="this.countdown < 2" class="countdown-text">
                        You have {{ countdown }} second to enter valid code
                      </span>
                    </div>
                  </div>

                  <!-- Error Attempts -->
                  <div v-if="this.errorcount > 0" class="error-attempts-section">
                    <div class="error-attempts-container">
                      <v-icon size="18" class="error-icon">mdi-alert-circle-outline</v-icon>
                      <span v-if="this.errorcount < 2" class="error-attempts-text">
                        You have {{ 3 - this.errorcount }} more attempts left
                      </span>
                      <span v-if="this.errorcount > 1" class="error-attempts-text">
                        You have {{ 3 - this.errorcount }} more attempt left
                      </span>
                    </div>
                  </div>

                  <!-- Error Message -->
                  <div v-if="this.loginerror !== ''" class="error-message-section">
                    <v-alert type="error" density="compact" class="auth2fa-error-alert">
                      <span class="blink">{{ this.loginerror }}</span>
                    </v-alert>
                  </div>

                  <!-- Verify Button -->
                  <div class="button-section">
                    <v-btn 
                      type="submit" 
                      form="check-login-form"
                      :disabled="auth2facode.length !== 6 || this.loading" 
                      :loading="loading"
                      color="#000000"
                      variant="outlined"
                      class="verify-btn"
                      size="large"
                      block
                      @click="auth2fa()"
                    >
                      <v-icon v-if="!loading" left>mdi-shield-check</v-icon>
                      <span v-if="!loading">Verify</span>
                      <span v-if="loading">Verifying..</span>
                    </v-btn>
                  </div>

                  <!-- Back to Login Link -->
                  <div class="back-link-section">
                    <span class="sign-up-text-policy">
                      Back to
                      <span class="link-accept-signup" @click="handleClickMenu('login')">
                        Log in
                      </span>
                    </span>
                  </div>

                </v-card-text>
              </v-card>

              <!-- Footer Links -->
              <div class="footer-links">
                <div class="footer-buttons-container">
                  <button 
                    class="footer-link-btn"
                    @click="handleClickMenu('Terms')"
                  >
                    <v-icon size="14" class="footer-link-icon">mdi-file-document-outline</v-icon>
                    <span>Terms of use</span>
                  </button>
                  
                  <div class="separator-dot"></div>
                  
                  <button 
                    class="footer-link-btn"
                    @click="handleClickMenu('Privacy')"
                  >
                    <v-icon size="14" class="footer-link-icon">mdi-shield-lock-outline</v-icon>
                    <span>Privacy policy</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LogoWhite from '../components/logo_white.vue';

export default {
  name: 'Auth2fa',

  components: {
    LogoWhite
  },
  data: () => ({
    delay: 80,
    validLogin: false,
    loading: false,

    user: null,
    auth2facode: '',
    loginerror: '',
    errorcount: 0,

    dynamicText: '',
    text: '2FA Code',
    countdown: 120,
    countdownTimer: null,
  }),
  mounted() {
    this.typeText(0);
    this.errorcount = 0;
    this.countdown = 120;
    this.loading = false;
    this.startCountdown();

    if (this.$store.getters.getUserData != null) {
      this.$router.push({ name: 'plan' });
    } else {
      if (!this.$store.getters.getauth2fa) {
        this.$router.push({ name: 'login' });
      }

      if (this.$store.getters.getpreLoginData === null) {
        this.$router.push({ name: 'login' });
      }
    }
  },
  beforeUnmount() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  destroyed() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  computed: {
  },
  created() {
    if (this.$refs.formlogin) {
      this.$refs.formlogin.resetValidation();
    }
    this.user = this.$store.getters.getpreLoginData;
  },
  methods: {
    startCountdown() {
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.countdownTimer);
          this.countdownFinished();
        }
      }, 1000);
    },
    countdownFinished() {
      this.$router.push({ name: 'login' });
    },
    onFinish() {
      this.loading = true
      this.auth2fa()
    },
    auth2fa() {
      this.loading = true
      this.validLogin = false;
      this.auth2facode = this.auth2facode.trim()

      this.$store.dispatch('auth2fa', {
        code: this.auth2facode,
        token: this.user.token
      }
      ).then(response => {
        this.gotorootdash();
        this.loading = false
      }).catch(error => {
        if (!error.response) {
          this.loginerror = 'Service is down.. Try again later!'
          this.loading = false
          this.auth2facode = ''
        } else {
          this.loading = false
          this.auth2facode = ''
          this.loginerror = '2FA verification failed..'
          this.errorcount += 1;
          if (this.errorcount > 2) {
            this.$router.push({ name: 'login' });
          }
        }
      });
    },
    gotorootdash() {
      if (this.$store.getters.getMuze) {
        window.location.href = 'https://muze.muzible.com';
      } else if (this.$store.getters.getNFT) {
        window.location.href = 'https://verse.muzible.com';
      } else {
        this.$router.push({ name: 'plan' });
      }
    },
    async typeText(num) {
      let i = 0;
      while (i < this.text.length) {
        await this.waitForMs(this.delay);
        this.dynamicText += this.text[i];
        i++;
      }
      await this.waitForMs(2000);
      if (num === 0) {
        this.text = 'Open Authenticator'
        this.dynamicText = '';
        this.typeText(1);
      } else if (num === 1) {
        this.text = 'Read the code'
        this.dynamicText = '';
        this.typeText(2);
      } else {
        await this.waitForMs(4000);
        this.dynamicText = '';
        this.text = 'Enter and verify'
        this.typeText(0)
      }
    },
    waitForMs(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    handleClickMenu(link) {
      if (link === 'Terms') {
        window.open('https://muzible.com/terms', '_blank');
      } else if (link === 'Privacy') {
        window.open('https://muzible.com/privacy', '_blank');
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    },

  },
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Auth2fa Root - Complete Override */
.auth2fa-root {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  height: 100dvh !important;
  overflow: hidden !important;
  z-index: 1 !important;
}

/* Auth2fa Scroll Container - Main Scrollable Area */
.auth2fa-scroll-container {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  background: linear-gradient(145deg, rgba(0, 0, 0, 0.95), rgba(18, 18, 18, 0.95));
  
  /* Smooth scrolling */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

/* Auth2fa Content Wrapper */
.auth2fa-content-wrapper {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 20px 60px 20px;
}

/* Logo Section */
.logo-section {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

.logo-clickable {
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.logo-clickable:hover {
  transform: scale(1.05);
  opacity: 0.9;
}

/* Typing Section */
.typing-section {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.typing-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
}

.typing-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 32px;
  font-weight: 600;
  color: white;
  text-align: center;
}

.cursor {
  display: inline-block;
  width: 3px;
  height: 32px;
  background-color: white;
  margin-left: 4px;
  animation: blink 0.6s linear infinite alternate;
}

@keyframes blink {
  0% { opacity: 1; }
  40% { opacity: 1; }
  60% { opacity: 0; }
  100% { opacity: 0; }
}

/* Auth2fa Card Section */
.auth2fa-card-section {
  display: flex;
  justify-content: center;
  min-width: 370px;
  max-width: 500px;
}

.auth2fa-card {
  width: 100%;
  max-width: 500px;
  animation: slideIn 0.4s ease forwards;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.auth2fa-form-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95)) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease;
}

.auth2fa-form-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
}

.auth2fa-form-content {
  padding: 32px 24px !important;
}

/* Countdown Section */
.countdown-section {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
  margin-top: 16px;
}

/* Error Attempts Section */
.error-attempts-section {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

/* Error Message Section */
.error-message-section {
  margin-bottom: 16px;
}

/* Button Section */
.button-section {
  margin-top: 8px;
  margin-bottom: 16px;
}

/* Back Link Section */
.back-link-section {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

/* OTP Input */
.otp-wrapper {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.otp-container {
  position: relative;
  width: 100%;
  max-width: 400px;
}

.otp-input :deep(.v-otp-input__content) {
  gap: 12px;
}

.otp-input :deep(.v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.otp-input :deep(.v-field--focused) {
  border-color: #1ff050 !important;
  box-shadow: 0 0 0 2px rgba(31, 240, 80, 0.2);
}

.otp-input :deep(.v-field__input) {
  color: white !important;
  font-size: 24px !important;
  font-weight: 700 !important;
  text-align: center;
  font-family: "Darker Grotesque", sans-serif !important;
}

.otp-input :deep(.v-field--disabled) {
  opacity: 0.5;
}

/* OTP Loading Overlay */
.otp-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 12px;
  backdrop-filter: blur(4px);
}

/* Countdown Container */
.countdown-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
}

.countdown-icon {
  color: rgba(255, 255, 255, 0.7);
}

.countdown-text {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px !important;
  color: rgba(255, 255, 255, 0.8) !important;
  font-weight: 500;
}

/* Error Attempts Container */
.error-attempts-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: rgba(227, 66, 52, 0.1);
  border: 1px solid rgba(227, 66, 52, 0.3);
  border-radius: 8px;
}

.error-icon {
  color: #E34234;
}

.error-attempts-text {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px !important;
  color: #E34234 !important;
  font-weight: 500;
}

/* Error Alert */
.auth2fa-error-alert {
  width: 100%;
  margin: 0 !important;
}

.auth2fa-error-alert .blink {
  -webkit-animation: blinkError 1.5s infinite both;
  animation: blinkError 1.5s infinite both;
}

@keyframes blinkError {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Verify Button */
.verify-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  padding: 24px !important;
  border: 2px solid rgba(31, 240, 80, 0.5) !important;
  background: linear-gradient(135deg, rgba(31, 240, 80, 0.1) 0%, rgba(31, 240, 80, 0.05) 100%) !important;
  color: #1ff050 !important;
  transition: all 0.3s ease;
}

.verify-btn:hover:not(:disabled) {
  border-color: rgba(31, 240, 80, 0.8) !important;
  background: linear-gradient(135deg, rgba(31, 240, 80, 0.2) 0%, rgba(31, 240, 80, 0.1) 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(31, 240, 80, 0.2);
}

.verify-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: rgba(255, 255, 255, 0.4) !important;
  background: rgba(255, 255, 255, 0.05) !important;
}

/* Back to Login Link */
.sign-up-text-policy {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  color: rgba(255, 255, 255, 0.7) !important;
  text-align: center;
}

.link-accept-signup {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  color: #1ff050 !important;
  text-decoration: underline !important;
  text-decoration-style: solid !important;
  text-decoration-color: #1ff050 !important;
  text-underline-offset: 4px !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.link-accept-signup:hover {
  text-decoration-thickness: 2px !important;
  opacity: 0.8;
}

/* Footer Links */
.footer-links {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-buttons-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.footer-link-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  outline: none;
}

.footer-link-btn:hover {
  color: white;
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.footer-link-btn:active {
  transform: translateY(0);
}

.footer-link-icon {
  opacity: 0.8;
}

.separator-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
}

/* Button Overlay Override */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .auth2fa-content-wrapper {
    padding: 120px 16px 60px 16px;
  }

  .typing-text {
    font-size: 24px;
  }

  .cursor {
    height: 24px;
  }

  .auth2fa-form-content {
    padding: 24px 20px !important;
  }

  .otp-wrapper {
    padding: 20px 0;
  }

  .otp-input :deep(.v-otp-input__content) {
    gap: 8px;
  }

  .otp-input :deep(.v-field__input) {
    font-size: 20px !important;
  }

  .verify-btn {
    font-size: 16px !important;
    padding: 20px !important;
  }

  .countdown-container,
  .error-attempts-container {
    padding: 10px 16px;
  }

  .countdown-text,
  .error-attempts-text {
    font-size: 13px !important;
  }

  .footer-links {
    margin-top: 24px;
    padding-top: 20px;
  }

  .footer-buttons-container {
    gap: 12px;
  }

  .footer-link-btn {
    padding: 6px 12px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .auth2fa-content-wrapper {
    padding: 80px 16px 60px 16px;
  }

  .typing-text {
    font-size: 20px;
  }

  .cursor {
    height: 20px;
  }

  .auth2fa-form-content {
    padding: 20px 16px !important;
  }

  .otp-input :deep(.v-otp-input__content) {
    gap: 6px;
  }

  .otp-input :deep(.v-field__input) {
    font-size: 18px !important;
  }

  .countdown-container,
  .error-attempts-container {
    flex-direction: column;
    text-align: center;
    gap: 4px;
  }

  .footer-buttons-container {
    flex-direction: column;
    gap: 8px;
  }

  .separator-dot {
    display: none;
  }

  .footer-link-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Loading State for Button */
.verify-btn :deep(.v-btn__loader) {
  color: #1ff050 !important;
}

/* Accessibility */
.verify-btn:focus-visible {
  outline: 2px solid #1ff050;
  outline-offset: 2px;
}

.link-accept-signup:focus-visible {
  outline: 2px solid #1ff050;
  outline-offset: 2px;
  border-radius: 4px;
}

.footer-link-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

/* OTP Input Focus */
.otp-input :deep(.v-field:focus-within) {
  transform: scale(1.02);
}

</style>